import { Route, routerPush } from "src/common/routing";
import { TrackingEvent } from "src/common/trackingEvents";
import { useSegment } from "src/technical-integrations/segment/useSegment";
import useToggle from "src/hooks/useToggle";

export const useMultiAccountExitFlow = ({
  currentRoute,
}: {
  currentRoute: Route;
}) => {
  const { sendEvent } = useSegment();

  const { isOn: isExitDialogOpen, on, off: closeExitDialog } = useToggle(false);

  const openExitDialog = () => {
    on();
    sendEvent(TrackingEvent.MULTI_ACCOUNT_EXIT_CTA_CLICKED, {
      ctx: currentRoute,
    });
  };

  const exitFlow = () => {
    routerPush({ route: Route.Home });
    sendEvent(TrackingEvent.MULTI_ACCOUNT_GO_TO_DASHBOARD_CTA_CLICKED, {
      ctx: currentRoute,
    });
  };

  return {
    openExitDialog,
    exitFlow,
    isExitDialogOpen,
    closeExitDialog,
  };
};
